import AddRequestForm from './add-request-form';

interface IProps {
    centerId: number,
    isSuperUser: boolean
}

const AddRequest = (props: IProps) => {
    return (
        <AddRequestForm
            centerId={props.centerId}
            isSuperUser={props.isSuperUser}
        />
    );
}

export default AddRequest;